import moment from 'moment'
import React from 'react'
import appConfig from '../../../config/appConfig'

const MessageList = ({data}) => {

    const isIncoming = data.type == 'in';
    const isOutgoing = data.type == 'out';

    // console.log(appConfig)
    return (
        <div style={{width: '100%'}} className={`${isIncoming ? "justify-content-start" : "justify-content-end" } d-flex mb-2`}>
            <div className={`${isIncoming ? "bg-light" : "bg-dark" } p-2 rounded`} style={{minWidth: '120px', maxWidth: '70%'}}>
                {
                    // Nom de l'expéditeur pour les messages entrants
                    isIncoming && data.senderName && (
                        <p className="m-0 font-weight-bold" style={{fontSize: '11px'}}>
                            {data.senderName}
                        </p>
                    )
                }
                {
                    // Nom de l'expéditeur (send_by) pour les messages sortants
                    isOutgoing && data.send_by && (
                        <p className="m-0 font-weight-bold text-light" style={{fontSize: '11px'}}>
                            {data.send_by}
                        </p>
                    )
                }
                <p className={`${isIncoming ? "" : "text-light" } m-0`} style={{fontSize: '13px'}}>
                    {data.message}
                </p>
                {
                    data.medias && data.medias.length ? (
                        <div className='text-right'>
                                <div style={{fontSize: '10px'}} className='border rounded-lg p-2 text-muted d-flex justify-content-between align-items-center'>
                                    <i className={`fa fa-file mr-1`} style={{fontSize: '10px'}}></i>
                                    <span className='text-capitalize'></span>
                                    <a href={appConfig.apiDomaine+data.medias[0]} target="_blank" rel="noopener noreferrer" className='ml-1 text-decoration-none' style={{cursor: 'pointer'}}>
                                        <i className='fa fa-download'></i>
                                    </a>
                                </div>
                            </div>
                    ) : null
                }
                <div className='text-right'>
                    <span className={`${data.type=='in' ? "" : "text-muted" }`}  style={{fontSize: '10px'}}>
                        {moment(data.created_at).format("LT")}
                    </span>
                </div>
            </div>
        </div>
    )
}

export default MessageList